export default "__VITE_ASSET__BZt8DyU5__"